import React from "react";
import { SectorSelect } from "newui/components/ui/CommonSelects/SectorSelect";
import type { SelectOption } from "newui/components/ui/InputWithLabel/SelectWithLabel";
import type { ShortlistIngress } from "../../types";

interface SectorFilterPanelProps {
	sectorIds: number[];
	ingress: ShortlistIngress;
	onSectorIdsChange: (sectorIds: number[]) => void;
}

const SectorFilterPanel: React.FC<SectorFilterPanelProps> = ({
	sectorIds,
	ingress,
	onSectorIdsChange,
}) => {
	const handleChange = (selected: SelectOption | SelectOption[] | null) => {
		if (!selected) {
			onSectorIdsChange([]);
			return;
		}
		const ids = Array.isArray(selected)
			? selected.map((s) => s.value as number)
			: [selected.value as number];
		onSectorIdsChange(ids);
	};

	return (
		<div className="rounded-lg border border-gray-200 p-4">
			<h3 className="mb-1 text-sm font-semibold uppercase tracking-wide text-gray-700">
				Sector Filter
			</h3>
			<p className="mb-3 text-xs text-gray-500">
				{ingress === "search"
					? "Modify to filter project metrics, project summary, and key resources."
					: "Select sectors to filter report data. Leave empty to show unfiltered data."}
			</p>
			<SectorSelect
				name="sectorFilter"
				label=""
				noLabel
				isMulti
				placeholder="Select sectors..."
				selectedIds={sectorIds}
				onChange={handleChange}
				clearAble
			/>
			{sectorIds.length === 0 && ingress === "supplier-list" && (
				<p className="mt-2 text-xs text-amber-600">
					No sector filter applied — report will show all data.
				</p>
			)}
		</div>
	);
};

export default SectorFilterPanel;
